export default "__VITE_ASSET__39286ab1__"